module.exports = __webpack_public_path__ + "static/media/Gallery_Slider_3-min.b97c8e99.jpg";